import { render, staticRenderFns } from "./substitute-login.vue?vue&type=template&id=0315c61a&scoped=true&"
import script from "./substitute-login.vue?vue&type=script&lang=js&"
export * from "./substitute-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315c61a",
  null
  
)

export default component.exports